import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Button, {
  ButtonSizes,
  ButtonTypes,
} from '@lib/components/Button/Button';
import DocumentFormFieldNames from '@lib/enums/fieldNames/documentFormFieldNames';

type Props = {
  allowDownload: boolean;
  allowPrint: boolean;
};

// Resets the two document-level permission checkboxes back to the currently
// selected category's values, clearing the "custom permissions" state.
export default function UseCategoryDefaultsAction({
  allowDownload,
  allowPrint,
}: Props) {
  const { t } = useTranslation();
  const { setValue } = useFormContext();

  const onClick = () => {
    setValue(DocumentFormFieldNames.AllowDownload, allowDownload, {
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue(DocumentFormFieldNames.AllowPrint, allowPrint, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  return (
    <Button
      buttonText={t('use-category-defaults')}
      buttonType={ButtonTypes.primaryText}
      buttonSize={ButtonSizes.small}
      onClick={onClick}
    />
  );
}
